// components/SHEventInfoPageHeader.js
import React, { useState } from 'react';
import './SHEventInfoPageHeader.css';
import { FaShareAlt, FaChevronLeft } from 'react-icons/fa';
import { TbShare } from 'react-icons/tb';
import { useLanguage } from '../../../../LanguageProvider';
import { useToaster } from '../../../../ToasterProvider';


export default function SHEventInfoPageHeader({ activeTab, setActiveTab, tabs, setSelectedEvent, event }) {
    const { getTranslation } = useLanguage();
    const { toastError, toastSuccess } = useToaster();

    const handleCopy = () => {
        if (activeTab === getTranslation('details')) {
            navigator.clipboard.writeText("https://lodos.sh/event/" + event.eventID + "/details"
            )
                .then(() => {
                    toastSuccess(getTranslation("copiedToClipboard"));
                })
                .catch(err => {
                    console.error('Kopyalama başarısız:', err);
                });
        }

        else if (activeTab === getTranslation('speakers')) {
            navigator.clipboard.writeText("https://lodos.sh/event/" + event.eventID + "/speakers"
            )
                .then(() => {
                    toastSuccess(getTranslation("copiedToClipboard"));
                })
                .catch(err => {
                    console.error('Kopyalama başarısız:', err);
                });
        }

        else if (activeTab === getTranslation('tickets')) {
            navigator.clipboard.writeText("https://lodos.sh/event/" + event.eventID + "/tickets"
            )
                .then(() => {
                    toastSuccess(getTranslation("copiedToClipboard"));
                })
                .catch(err => {
                    console.error('Kopyalama başarısız:', err);
                });
        }

        else if (activeTab === getTranslation('sponsors')) {
            navigator.clipboard.writeText("https://lodos.sh/event/" + event.eventID + "/sponsors"
            )
                .then(() => {
                    toastSuccess(getTranslation("copiedToClipboard"));
                })
                .catch(err => {
                    console.error('Kopyalama başarısız:', err);
                });
        }
    };

    return (
        <div className="sh-info-header-container">
            <div className="sh-info-header-tabs">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        className={`sh-info-header-tab ${activeTab === tab ? 'sh-info-header-tab-active' : ''
                            }`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </button>
                ))}

                <div className="sh-info-header-actions" style={{ marginLeft: 'auto' }}>
                    {(activeTab !== getTranslation("soldTickets") && activeTab !== getTranslation("myTickets") && activeTab !== getTranslation("settings") && activeTab !== getTranslation("bulkTicketEntry")) && 
                        <button
                            onClick={handleCopy}
                            className="kronos-add-manual-button"
                            style={{ gap: '10px' }}
                        >
                            <TbShare style={{ marginTop: '3px' }} />
                            {getTranslation('copyShareLink')}
                        </button>
                    }


                    <button
                        onClick={() => setSelectedEvent(null)}
                        className="kronos-add-manual-button"
                        style={{ width: '34px', height: '34px', padding: 0 }}
                    >
                        <FaChevronLeft />
                    </button>

                </div>
            </div>

        </div>
    );
}
